import * as React from "react";
import { SVGProps } from "react";
const SvgSave = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#save_svg__a)">
      <path
        fill="currentColor"
        d="M23.377 8.16a2 2 0 0 1 1 1.732v2.92c.812.783 1.49 1.692 2.01 2.693h1.615a2.002 2.002 0 0 1 2 2v5a2.002 2.002 0 0 1-2 2h-1.615c-.38.73-.844 1.411-1.385 2.03v3.47a2.002 2.002 0 0 1-2 2h-3a2.002 2.002 0 0 1-1.971-1.665 12.51 12.51 0 0 1-4.057 0 2.002 2.002 0 0 1-1.972 1.666h-3a2.002 2.002 0 0 1-2-2v-3.47a10.126 10.126 0 0 1-1.84-3.047 3.5 3.5 0 0 1 0-6.967c1.881-4.886 7.576-7.974 13.41-6.742l2.805-1.62a2 2 0 0 1 2 0Zm-1 1.732-3.492 2.016-.389-.095c-5.227-1.27-10.328 1.572-11.656 5.98l-.215.713H5.502a1.5 1.5 0 0 0 0 3h1.123l.215.712a8.132 8.132 0 0 0 1.89 3.248l.272.288v4.252h3v-2.204l1.26.34c1.795.483 3.686.483 5.48 0l1.26-.34v2.204h3v-4.252l.272-.289a8.338 8.338 0 0 0 1.567-2.361l.263-.598h2.898v-5h-2.898l-.263-.598a8.426 8.426 0 0 0-2.13-2.915l-.334-.298V9.892Zm-1.375 5.614a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM8.048 2.274a5.499 5.499 0 0 1 9.417 5.592c-.481-.047-.968-.075-1.463-.075a14.475 14.475 0 0 0-7.118 1.85 5.5 5.5 0 0 1-.836-7.367Z"
      />
    </g>
    <defs>
      <clipPath id="save_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSave;
